import { Group } from '@wellesley/openapi'
import { selectUploadFile } from '@wellesley/uploads'
import { RecentSearch, AddRecentSearch } from '../../types/search'

export const getGroupAvatarSrc = (group?: Group | null): string => {
  return (
    selectUploadFile({
      size: 24,
      upload: group?.avatar,
    })?.uri || ''
  )
}

export const createGroupRecentSearch = (
  group: Group | null | undefined,
  groupName: string,
  searchValue?: string,
): Omit<RecentSearch, 'id'> => {
  return {
    type: 'group',
    title: group?.displayName ?? groupName,
    value: group?.groupName ?? groupName,
    avatarSrc: getGroupAvatarSrc(group),
    ...(searchValue ? { searchValue: searchValue.trim() } : {}),
  }
}

export const addRecentSearches = ({
  searchInput,
  groupName,
  group,
  addRecentSearch,
}: {
  searchInput: string
  groupName?: string
  group?: Group | null
  addRecentSearch: AddRecentSearch
}) => {
  const trimmed = searchInput.trim()
  if (!trimmed) return

  if (groupName && group) {
    addRecentSearch([createGroupRecentSearch(group, groupName, trimmed)])
  } else {
    addRecentSearch([{ type: 'query', value: trimmed }])
  }
}

export const buildSearchParams = ({
  query,
  groupName,
  filter,
}: {
  query?: string
  groupName?: string
  filter?: string
}): Record<string, string> => {
  const params: Record<string, string> = {}
  if (filter) {
    params.filter = filter
  }
  if (query?.trim()) {
    params.q = query.trim()
  }
  if (groupName) {
    params.groupName = groupName
  }
  return params
}
